(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('legal_actualInformation', {
                parent: 'app',
                url: '/legal_actual-information',
                controller: 'LegalActualInfoController',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'global.menu.account.legal_actual'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/legal-actual-info/index.html',
                        controller: 'LegalActualInfoController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('legal_actualInformation');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'UserProfileQuery', function ($stateParams, UserProfileQuery) {

                        return UserProfileQuery.getCurrentPersonInfo().query();
                    }]
                }
//                  resolve: {
//                    entity: function(MyService, $stateParams) {
//                      return MyService.get($stateParams.id).$promise;
//                    }
//                  }


            })


        ;
    }

})();
